export default __webpack_public_path__ + "static/media/Proposals.351c0d6b.svg";